export default "__VITE_ASSET__Wgrlcy0W__"